<template>
  <PackSlots v-if="gameStore.getGamePack?.pack_slots" />
  <div class="d-flex-row space-between lg-row-to-col">
    <rank-division-pick
      :type="'currentRank'"
      item-key="rankBoosting"
      :title="$t('calculators_common.current_rank')"
      class="flex-5 flex-lg-10"
    />
    <DoubleRight />
    <rank-division-pick
      :type="'desiredRank'"
      item-key="rankBoosting"
      :prev-rank="checkoutStore.getDetails.currentRank"
      :title="$t('calculators_common.desired_rank')"
      class="flex-5 flex-lg-10"
    />
  </div>
  <!-- BECOME LEGEND -->
  <div
    class="become_legend marvel-rivals b-radius-9 d-flex-row space-between"
    style="margin-bottom: 20px"
    @click="handleMidSeason"
    v-if="midSeason"
    :class="[checkoutStore.getPackExtraOptions?.midSeason && 'active']"
  >
    <img
      src="/images/games/marvel-rivals-boost/banner_bg.webp"
      class="become_a_legend_bg"
      alt="Become Legend Bg"
    />

    <div class="d-flex-row flex-8 justify-start">
      <img
        src="/images/games/marvel-rivals-boost/packs/marvel-rivals-one-above-all-boost.webp"
        alt="become legend"
        height="48"
        width="44"
      />

      <div class="d-flex-column justify-start align-start gap-0">
        <label class="bold-xl font-family-2 t-white">
          {{ $t("mid_season_oaa") }}
        </label>
        <p class="regular-m font-family-2 t-light">
          {{ $t("mid_season_oaa_desc") }}
        </p>
      </div>
    </div>

    <div class="d-flex-row flex-2 justify-end">
      <Switch :checked="checkoutStore.getPackExtraOptions?.midSeason" />
    </div>
  </div>
  <ExtraOptionPicker />
  <PlatformPicker />
  <OptionPicker />

  <RolesPicker :select-only-one-role="true" :max1="true" />
  <ChampionsPicker />
</template>

<script setup>
import PlatformPicker from "../commonpickers/PlatformPicker.vue";
import DoubleRight from "~/components/icons/DoubleRight.vue";
import ExtraOptionPicker from "./pickers/ExtraOptionPicker.vue";
import OptionPicker from "./pickers/OptionPicker.vue";
import RolesPicker from "../lol/pickers/RolesPicker.vue";
import ChampionsPicker from "../commonpickers/ChampionsPicker.vue";
import RankDivisionPick from "./pickers/RankDivisionPickerOld.vue";
import Switch from "~/components/custom/Switch.vue";
import PackSlots from "~/components/common/PackSlots.vue";

const checkoutStore = useCheckoutStore();
const gameStore = useGameStore();

const handleDetails = () => {
  checkoutStore.clearCheckout();
  checkoutStore.setOneRole({
    roleId: gameStore.getGame.roles[0]?.id,
  });
  // const currentRank = gameStore.getGameRanks || []
  if (gameStore.getGameRanks?.length > 0) {
    const currentRank = gameStore.getGameRanks[0];
    const desiredRank = gameStore.getGameRanks[8];
    checkoutStore.setDetails({
      currentDivision: currentRank.divisions[0]?.id,
      currentDivisionTitle: currentRank.divisions[0]?.title,
      currentRank: currentRank.id,
      currentRankTitle: currentRank.title,
      desiredDivision: null,
      desiredDivisionTitle: null,
      desiredRank: desiredRank.id,
      desiredRankTitle: desiredRank.title,
    });
  }

  checkoutStore.setServer(gameStore.getGame.servers[0]?.id);
  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setGameAndPack({
    game: gameStore.getGame.id,
    pack: gameStore.getGamePack.id,
    fullGame: gameStore.getGame,
    fullPack: gameStore.getGamePack,
  });
};

handleDetails();
onNuxtReady(() => {
  checkoutStore.setCalculating();
});
const midSeason = computed(() => {
  return gameStore.getGamePack?.pack_extra_options?.find(
    (op) => op.description === "mid-season-oaa"
  );
});

const handleMidSeason = () => {
  // console.log(midSeason.value);
  if (!midSeason.value) return;
  console.log(midSeason.value?.id);
  if (midSeason.value?.id && !checkoutStore.getPackExtraOptions?.midSeason) {
    checkoutStore.setPackExtraOptions({
      midSeason: midSeason.value?.id,
    });
  } else if (
    midSeason.value?.id &&
    checkoutStore.getPackExtraOptions?.midSeason
  ) {
    delete checkoutStore.packExtraOptions?.midSeason;
  }
};
</script>
